var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscardPileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 227,
    viewBox: "0 0 290 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 148.282L107.821 73.322L271.021 146.258L168.2 221.302L5 148.282Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44212 148.029L107.905 74.6711L268.495 146.511L168.032 219.868L7.44212 148.029ZM271.021 146.258L107.821 73.322L5.08423 148.366L168.284 221.386L271.021 146.258Z",
    fill: "white",
    stroke: "#5E5E5E",
    strokeWidth: 4.1404,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 148.282L107.821 73.322L271.021 146.258L168.2 221.302L5 148.282Z",
    stroke: "#5E5E5E",
    strokeWidth: 4.1404,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5896 134.538L115.569 70.5395L270.348 160.086L160.453 224L5.5896 134.538Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11592 134.538L115.653 71.9729L267.99 160.002L160.453 222.567L8.11592 134.538ZM270.348 160.086L115.569 70.5395L5.5896 134.538L160.369 224L270.348 160.086Z",
    fill: "white",
    stroke: "#5E5E5E",
    strokeWidth: 4.1404,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5896 134.538L115.569 70.5395L270.348 160.086L160.453 224L5.5896 134.538Z",
    stroke: "#5E5E5E",
    strokeWidth: 4.1404,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9895 145.499L116.663 62.7822L285 122.986L188.326 205.703L19.9895 145.499Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3474 145.077L116.916 64.2156L282.558 123.408L187.989 204.269L22.3474 145.077ZM285 122.986L116.663 62.7822L19.9895 145.499L188.326 205.703L285 122.986Z",
    fill: "white",
    stroke: "#5E5E5E",
    strokeWidth: 4.1404,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9895 145.499L116.663 62.7822L285 122.986L188.326 205.703L19.9895 145.499Z",
    stroke: "#5E5E5E",
    strokeWidth: 4.1404,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9895 121.468L121.968 57.5544L276.747 147.017L166.768 211.015L11.9895 121.468Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4316 121.468L121.968 58.9035L274.305 146.932L166.768 209.497L14.4316 121.468ZM276.747 147.017L121.968 57.5544L11.9895 121.468L166.768 210.931L276.747 147.017Z",
    fill: "white",
    stroke: "#5E5E5E",
    strokeWidth: 4.1404,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9895 121.468L121.968 57.5544L276.747 147.017L166.768 211.015L11.9895 121.468Z",
    stroke: "#5E5E5E",
    strokeWidth: 4.1404,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0527 110.591L119.947 46.5929L274.811 136.055L164.832 200.053L10.0527 110.591Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4948 110.591L120.032 48.0263L272.368 136.055L164.832 198.62L12.4948 110.591ZM274.811 136.055L119.947 46.5929L10.0527 110.591L164.832 200.053L274.811 136.055Z",
    fill: "white",
    stroke: "#5E5E5E",
    strokeWidth: 4.1404,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0527 110.591L119.947 46.5929L274.811 136.055L164.832 200.053L10.0527 110.591Z",
    stroke: "#5E5E5E",
    strokeWidth: 4.1404,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4949 101.485L122.39 37.4865L277.253 126.949L167.274 190.947L12.4949 101.485Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.937 101.485L122.474 38.9199L274.811 126.949L167.274 189.514L14.937 101.485ZM277.253 126.949L122.39 37.4865L12.4949 101.485L167.274 190.947L277.253 126.949Z",
    fill: "white",
    stroke: "#5E5E5E",
    strokeWidth: 4.1404,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4949 101.485L122.39 37.4865L277.253 126.949L167.274 190.947L12.4949 101.485Z",
    stroke: "#5E5E5E",
    strokeWidth: 4.1404,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37891 104.773L112.2 29.8134L275.4 102.834L172.579 177.793L9.37891 104.773Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.821 104.52L112.284 31.1625L272.874 103.002L172.495 176.36L11.821 104.52ZM275.4 102.834L112.2 29.8134L9.46313 104.857L172.663 177.878L275.4 102.834Z",
    fill: "white",
    stroke: "#5E5E5E",
    strokeWidth: 4.1404,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37891 104.773L112.2 29.8134L275.4 102.834L172.579 177.793L9.37891 104.773Z",
    stroke: "#5E5E5E",
    strokeWidth: 4.1404,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0527 91.029L119.947 27.0309L274.811 116.578L164.832 180.576L10.0527 91.029Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4948 91.029L120.032 28.4643L272.368 116.493L164.832 179.058L12.4948 91.029ZM274.811 116.578L119.947 27.0309L10.0527 91.029L164.832 180.576L274.811 116.578Z",
    fill: "white",
    stroke: "#5E5E5E",
    strokeWidth: 4.1404,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0527 91.029L119.947 27.0309L274.811 116.578L164.832 180.576L10.0527 91.029Z",
    stroke: "#5E5E5E",
    strokeWidth: 4.1404,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1052 54.013L135.526 13.0339L269.674 131.418L149.253 172.397L15.1052 54.013Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5473 54.5189L135.274 14.4674L267.232 130.912L149.505 170.963L17.5473 54.5189ZM269.674 131.418L135.526 13.0339L15.1052 54.013L149.253 172.312L269.674 131.418Z",
    fill: "white",
    stroke: "#5E5E5E",
    strokeWidth: 4.1404,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1052 54.013L135.526 13.0339L269.674 131.418L149.253 172.397L15.1052 54.013Z",
    stroke: "#5E5E5E",
    strokeWidth: 4.1404,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3684 78.0439L126.347 14.0458L281.211 103.508L171.232 167.506L16.3684 78.0439Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8947 78.0439L126.432 15.4792L278.768 103.508L171.232 166.073L18.8947 78.0439ZM281.211 103.508L126.347 14.0458L16.3684 78.0439L171.147 167.506L281.211 103.508Z",
    fill: "white",
    stroke: "#5E5E5E",
    strokeWidth: 4.1404,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3684 78.0439L126.347 14.0458L281.211 103.508L171.232 167.506L16.3684 78.0439Z",
    stroke: "#5E5E5E",
    strokeWidth: 4.1404,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9158 97.6902L105.968 10.8417L276.747 63.7097L183.695 150.474L12.9158 97.6902Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3579 97.1L106.305 12.1908L274.389 64.2156L183.442 149.125L15.3579 97.1ZM276.747 63.7097L105.968 10.8417L12.9158 97.6902L183.695 150.558L276.747 63.7097Z",
    fill: "white",
    stroke: "#5E5E5E",
    strokeWidth: 4.1404,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9158 97.6902L105.968 10.8417L276.747 63.7097L183.695 150.474L12.9158 97.6902Z",
    stroke: "#5E5E5E",
    strokeWidth: 4.1404,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51587 58.0603L121.211 3L268.411 104.436L153.8 159.496L6.51587 58.0603Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95797 58.2289L121.126 4.43342L265.969 104.267L153.884 158.147L8.95797 58.2289ZM268.411 104.436L121.211 3L6.51587 58.0603L153.8 159.496L268.411 104.436Z",
    fill: "white",
    stroke: "#5E5E5E",
    strokeWidth: 4.1404,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51587 58.0603L121.211 3L268.411 104.436L153.8 159.496L6.51587 58.0603Z",
    stroke: "#5E5E5E",
    strokeWidth: 4.1404,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M20.158 67.9256L130.053 3.92749L284.916 93.3899L174.937 157.388L20.158 67.9256Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6001 67.9256L130.137 5.36091L282.474 93.3899L174.937 155.955L22.6001 67.9256ZM284.916 93.3899L130.053 3.92749L20.158 67.9256L174.937 157.388L284.916 93.3899Z",
    fill: "white",
    stroke: "#5E5E5E",
    strokeWidth: 4.1404,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M20.158 67.9256L130.053 3.92749L284.916 93.3899L174.937 157.388L20.158 67.9256Z",
    stroke: "#5E5E5E",
    strokeWidth: 4.1404,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscardPileIcon);
export default __webpack_public_path__ + "static/media/DiscardPileIcon.9a5ce623cbbfef7538826e219c8d79dc.svg";
export { ForwardRef as ReactComponent };